import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EducationLevel } from '../entities/education-level';

@Injectable()
export class EducationLevelService extends BaseCrudService<EducationLevel> {

  public uri = '/api/educationLevel/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EducationLevelService');
  }

  buildSentence(entity?: EducationLevel, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
            `row${QueryOperator.Equal}${entity.row}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.startDate ?
            `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.endDate ?
            `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.certificateNumber ?
            `certificateNumber${QueryOperator.Contain}${entity.certificateNumber}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.certificateDate ?
            `certificateDate${QueryOperator.Equal}${entity.certificateDate}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.durationTime ?
            `durationTime${QueryOperator.Equal}${entity.durationTime}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.registerNumber ?
            `registerNumber${QueryOperator.Contain}${entity.registerNumber}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.serialNumber ?
            `serialNumber${QueryOperator.Contain}${entity.serialNumber}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.subscriptionNumber ?
            `subscriptionNumber${QueryOperator.Contain}${entity.subscriptionNumber}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.comment ?
            `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.isMember ?
          `isMember${QueryOperator.Equal}${entity.isMember}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.membershipNumber ?
            `membershipNumber${QueryOperator.Contain}${entity.membershipNumber}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      query = query.concat(
        entity.membershipDate ?
            `membershipDate${QueryOperator.Equal}${entity.membershipDate}${QueryOperator.Split}`
            : QueryOperator.Empty
      );
      if (entity.educationType && entity.educationType.id) {
        query = query.concat(
          `educationType.id${QueryOperator.Equal}${entity.educationType.id}${QueryOperator.Split}`
        );
      }
      if (entity.studyCenter && entity.studyCenter.id) {
        query = query.concat(
          `studyCenter.id${QueryOperator.Equal}${entity.studyCenter.id}${QueryOperator.Split}`
        );
      }
      if (entity.specialty && entity.specialty.id) {
        query = query.concat(
          `specialty.id${QueryOperator.Equal}${entity.specialty.id}${QueryOperator.Split}`
        );
      }
      if (entity.supportingDocument && entity.supportingDocument.id) {
        query = query.concat(
          `supportingDocument.id${QueryOperator.Equal}${entity.supportingDocument.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
     /* if (entity.employee && entity.employee.id==undefined) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${0}${QueryOperator.Split}`
        );
      }*/
      if (entity.durationType && entity.durationType.id) {
        query = query.concat(
          `durationType.id${QueryOperator.Equal}${entity.durationType.id}${QueryOperator.Split}`
        );
      }
      if (entity.copyType && entity.copyType.id) {
        query = query.concat(
          `copyType.id${QueryOperator.Equal}${entity.copyType.id}${QueryOperator.Split}`
        );
      }
      if (entity.studyCenterMember && entity.studyCenterMember.id) {
        query = query.concat(
          `studyCenterMember.id${QueryOperator.Equal}${entity.studyCenterMember.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/education-level.service.ts